export const plantType = {
    houseplant: 'houseplant',
    landscape: 'landscape',
    lawn: 'lawn'
}

export const BACKEND_URL = 'https://plant-hospital.firebaseapp.com/'
export const MAIN = '#69b39c'
export const DISABLED = '#b1b1b1'
export const BACKGROUND = '#d3f2e8'

//variables para la animacion del titulo
export const titleAnimation = {
    inputRange: [50, 90],
    outputRange: [0, 1],
    extrapolate: 'clamp'
}